import { render, staticRenderFns } from "./StartupModel.vue?vue&type=template&id=80b865b2"
import script from "./StartupModel.vue?vue&type=script&lang=js"
export * from "./StartupModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports